import { render } from "./CostCenters.vue?vue&type=template&id=9c60e72a&lang=pug"
import script from "./CostCenters.vue?vue&type=script&setup=true&lang=js"
export * from "./CostCenters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__